import styled from 'styled-components';

export default styled.div`
	--gap: var(--spacing-x-large);
	position: fixed;
	top: 4rem;
	left: 0;
	right: 0;
	bottom: 0;
	pointer-events: none;
	display: flex;
	flex-direction: column;
	padding: var(--gap) var(--spacing-xxx-large);
	gap: var(--gap);
	z-index: 10;

	& > .motif-toast {
		pointer-events: all;
	}

	&.modal {
		position: absolute;
		padding: var(--gap);
		top: 0;
	}
`;
